import { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

export const ModalBody = ({ children }: Props) => {
  return <div className="p-6">{children}</div>;
};
